import { z } from 'zod';
import { badgeHistoryActions } from '../entities/BadgeHistoryEntityTypes';
export const logBadgeHistoryActionRequestSchema = z.object({
    badgeId: z.string().uuid(),
    accountBadgeIds: z.string().uuid().array().min(1),
    action: z.enum(badgeHistoryActions),
    note: z.string().optional(),
});
export const logBadgeHistoryActionResponseSchema = z.object({
    success: z.boolean(),
});
export const logBadgeHistoryActionFunctionDef = {
    name: 'logBadgeHistoryAction',
    requestSchema: logBadgeHistoryActionRequestSchema,
    responseSchema: logBadgeHistoryActionResponseSchema,
};
